import { GetStaticPaths } from "next"
import Head from "next/head"
import { t } from "translations"

import { getFooter } from "data/contentData/api/content"
import { getDictionary } from "data/contentData/api/dictionary"
import { getMegamenu } from "data/contentData/api/megamenu"
import { IMegamenuCategory } from "data/contentData/interfaces/IMegamenuCategory"
import { IContainerCard } from "data/contentData/interfaces/mongodb/IContainerCard"
import { IDictionaryTerm } from "data/contentData/interfaces/mongodb/IDictionaryTerm"

import GlossarySearch from "Components/Glossary/GlossarySearch"
import Layout from "Components/Layout/Layout"

export default function Dictionary({
    dictionary,
    footer,
    megamenu
}: {
    dictionary: IDictionaryTerm[]
    footer: IContainerCard[]
    megamenu: IMegamenuCategory[]
}) {
    if (dictionary === null) return null

    return (
        <Layout
            footer={footer}
            megamenu={megamenu}>
            <Head>
                <title>
                    {t.dictionary.title} - {t.siteTitle}
                </title>
                <meta
                    name="description"
                    content={`${t.dictionary.title} - ${t.siteTitle}`}
                    key="desc"
                />
            </Head>
            <GlossarySearch dictionary={dictionary} />
        </Layout>
    )
}

export async function getStaticProps() {
    const dictionary = await getDictionary()
    const footer = await getFooter()
    const megamenu = await getMegamenu()
    const revalidate = Number(process.env.REVALIDATE_STATIC_PROPS)

    return {
        props: {
            dictionary,
            footer,
            megamenu
        },
        revalidate
    }
}

export const getStaticPaths: GetStaticPaths = async () => {
    return {
        paths: [],
        fallback: "blocking" // false or 'blocking' -> true or revalidate() to run when needed
    }
}
